<footer fxLayout="row" fxLayoutAlign="space-between">
  <div fxLayout="column" fxLayoutAlign="center">V{{appVersion}} © {{year}} ADM</div>
  <div fxLayout="column" fxLayoutAlign="center"><a href="mailto:apps.support@adm.com">apps.support@adm.com</a></div>
</footer>
